export interface StickyPanelProps {
  stickyOffset?: number
  stickyZIndex?: number
}

export type PanelStickyPropsFn = (stickyZIndex: number) => StickyPanelProps

export const stickyPanelHeaderClassName =
  'relative sticky border-b border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800'
